import React, { useContext, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Popup from "../../../Helpers/Popup/Popup";
import Loader from "../../../Helpers/Loader/Loader";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import RegularInfo from "./RegularInfo";
import { useGetRegularMaintenanceByTraccarIdQuery } from "../../../../Redux/service/Maintenance/MaintenanceNew";
import { popupcontext } from "../../../../context/Popupscontext";

export default function RegularPopup({ id, type }) {
  let { handleClose, setCurrentMaintenanceId } = useContext(popupcontext);
  const { data, isFetching } = useGetRegularMaintenanceByTraccarIdQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,
  });
  const selected = data?.data;

  console.log("selected", selected);
  const close = () => {
    if (type === "maintenance") {
      handleClose("display");
    } else {
      setCurrentMaintenanceId(null);
    }
  };
  if (!selected && !isFetching) return <div>No data available.</div>;
  if (isFetching)
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  return (
    <Popup show={!!selected}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={selected.name} />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={close}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <RegularInfo data={selected} />
      </Modal.Body>
    </Popup>
  );
}
